import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// import { useMutation } from "react-query";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components/macro";
import PrimaryButton from "../../components/custom/PrimaryButton";
// import Snackbar from "../../components/custom/Snackbar";
// import { stripeCheckout } from "../../services/upgradeYourPlan";
// import { stripeCheckoutSubscription } from "../../services/upgradeYourPlan";
import MoneyPerMonth from "./MoneyPerMonth";
import ProductCard from "./ProductCard";
import {
  customerPortal,
  customerPortalInfo,
} from "../../services/portalService";
import { stripeUpgradeSubscription } from "../../services/upgradeYourPlan";
import ButtonMenu from "../../components/custom/ButtonMenu";
import MessageDialog from "../../components/custom/MessageDialog";

function UpgradePlanCard({ data }) {
  const [searchParams] = useSearchParams();
  // ful is a url parameter, initialized in Buy Fulfillments button (dashboard)
  const ful = searchParams.get("ful");
  // const customer = JSON.parse(window.sessionStorage.getItem("customer"));
  const { t } = useTranslation();
  // const [setError] = useState("");
  const [openDialog, setOpenDialog] = useState(false);

  // console.log(openProductsDialog);
  const publisherSubscriptionInfo = JSON.parse(
    window.sessionStorage.getItem("publisherSubscriptionInfo")
  );
  const displayPlans = JSON.parse(
    window.sessionStorage.getItem("displayFulfillmentProducts")
  );
  // const customer = JSON.parse(window.sessionStorage.getItem("customer"));

  // const { mutate } = useMutation(stripeCheckoutSubscription, {
  //   onSettled: (data, error, variables, context) => {},
  // });
  // const handleSubscription = (data) => {
  //   const map = new Map();
  //   map.set("publisherId", customer?.publisherId);
  //   mutate({
  //     customerId: customer?.stripeId,
  //     productId: data?.product?.productId,
  //     priceId: data?.subscriptionProductPrice?.priceId,
  //     parametersMap: { publisherId: customer?.publisherId },
  //   });
  // };

  //  const navigate = useNavigate();
  // const { mutate } = useMutation(stripeCheckout, {
  //   onSuccess: (data) => {
  //     //  navigate("/paymentSuccess");
  //     setOpenDialog(false);
  //   },
  //   onError: (error) => {
  //     switch (error) {
  //       default: {
  //         setError(t("A network error occured. Please try again later"));
  //       }
  //     }
  //   },
  // });
  const owned =
    data?.subscriptionProductPrice?.productId ===
    publisherSubscriptionInfo?.productId;
  const [openProductsDialog, setOpenProductsDialog] = useState(ful && owned);

  // const isSubscribed = publisherSubscriptionInfo?.productId != null;

  // const handleBuyNow = () => {
  //   setOpenDialog(true);
  //   const map = new Map();
  //   map.set("publisherId", customer?.publisherId);
  //   mutate({
  //     customerId: customer?.stripeId,
  //     productId: data?.subscriptionProductPrice?.productId,
  //     priceId: data?.subscriptionProductPrice?.priceId,
  //     parametersMap: {
  //       publisherId: customer?.publisherId,
  //       mode: isSubscribed ? "UPDATE" : "CREATE",
  //     },
  //   });
  // };
  const [dialogConfig, setDialogConfig] = useState({
    open: false,
    message: "Billing information is missing!",
    hint: "Invoice cannot be generated beacuse your billing information is missing. Please click on the Update button and fill all necessary fields.",
    action: () => updateBillingInformation(publisherSubscriptionInfo),
  });

  const updateBillingInformation = async (publisherSubscriptionInfo) => {
    setOpenDialog(true);
    await customerPortalInfo(publisherSubscriptionInfo);
    setOpenDialog(false);
  };

  const handleClick = async (currentPlan) => {
    const res = await customerPortal(currentPlan);
    setOpenDialog(false);
    if (res?.response?.status === 424) {
      setDialogConfig((prev) => ({
        ...prev,
        open: true,
      }));
    }
  };

  const handleUpgradeSubscription = async (currentPlan) => {
    const res = await stripeUpgradeSubscription(currentPlan);
    setOpenDialog(false);
    if (res?.response?.status === 424) {
      setDialogConfig((prev) => ({
        ...prev,
        open: true,
      }));
    }
  };

  useEffect(() => {
    setOpenDialog(false);
  }, [window.location.pathname]);
  return (
    <>
      <CardBox>
        <StyledTypography sx={{ p: 1, ml: 3 }}>
          {data?.product?.name}
        </StyledTypography>
        <StyledPaper
          style={{
            borderStyle: "solid",
            borderColor:
              data?.subscriptionProductPrice?.productId ===
              publisherSubscriptionInfo?.productId
                ? "gold"
                : "none",
            borderWidth:
              data?.subscriptionProductPrice?.productId ===
              publisherSubscriptionInfo?.productId
                ? 5
                : 0,
          }}
        >
          <Grid
            container
            p={2}
            wrap="nowrap"
            direction="column"
            justifyContent="space-between"
            sx={{ height: "100%" }}
          >
            <Grid item container xs={2}>
              <Grid item>
                <Typography variant="h4">{data?.product?.name}</Typography>
              </Grid>
              <Grid>
                <Typography
                  fontWeight={"bold"}
                  color={"gold"}
                  variant="caption"
                  ml={1}
                >
                  {data?.subscriptionProductPrice?.productId ===
                  publisherSubscriptionInfo?.productId
                    ? "Current"
                    : ""}
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={8} container direction="column" spacing={2}>
              <Grid item>
                <Typography sx={{ fontSize: "0.7rem" }}>
                  {data?.product?.description}
                </Typography>
              </Grid>
              <Grid item>
                <StyledTypography>
                  {t("Max distributors")} : {data?.distributorsCountDescr}
                </StyledTypography>
              </Grid>
              <Grid item>
                <StyledTypography>
                  {t("Book Uploads")} : {data?.totalUploadedBooksDescr}
                </StyledTypography>
              </Grid>
            </Grid>
            <Grid
              item
              xs={2}
              container
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item xs={4}>
                <MoneyPerMonth price={data?.subscriptionProductPrice?.price} />
              </Grid>
              <Grid item xs={8}>
                <StyledBoxBuyButton>
                  <ButtonMenu
                    menuName={
                      data?.subscriptionProductPrice?.productId ===
                      publisherSubscriptionInfo?.productId
                        ? "HISTORY"
                        : t("CHANGE PLAN")
                    }
                    menuDisabled={!data?.allowed}
                    menuSingleItem={
                      data?.subscriptionProductPrice?.productId ===
                      publisherSubscriptionInfo?.productId
                    }
                    menuCardAction={() => {
                      setOpenDialog(true);
                      handleClick(data?.subscriptionProductPrice);
                    }}
                    menuBankAction={() => {
                      setOpenDialog(true);
                      handleUpgradeSubscription(data?.subscriptionProductPrice);
                      setTimeout(() => setOpenDialog(false), 4000);
                    }}
                  />
                </StyledBoxBuyButton>
                {/* <StyledBoxBuyButton>
                  <PrimaryButton
                    disabled={!data?.allowed}
                    onClick={() => {
                      setOpenDialog(true);
                      // if (
                      //   customer?.paymentType === "CARD" ||
                      //   data?.subscriptionProductPrice?.productId ===
                      //     publisherSubscriptionInfo?.productId
                      // ) {
                      customerPortal(data?.subscriptionProductPrice);
                      // } else {
                      //   stripeUpgradeSubscription(
                      //     data?.subscriptionProductPrice
                      //   );
                      //   setTimeout(() => setOpenDialog(false), 4000);
                      // }
                    }}
                  >
                    {data?.subscriptionProductPrice?.productId ===
                    publisherSubscriptionInfo?.productId
                      ? "HISTORY"
                      : t("CHANGE PLAN")}
                  </PrimaryButton>
                </StyledBoxBuyButton> */}
              </Grid>
            </Grid>
            {owned && displayPlans && (
              <StyledTypographyTransition
                variant="button"
                style={{ cursor: "pointer" }}
                onClick={() => setOpenProductsDialog(true)}
              >
                see plan's products
              </StyledTypographyTransition>
            )}
          </Grid>
        </StyledPaper>
      </CardBox>
      <Dialog open={openDialog}>
        <DialogContent>{"Redirecting to billing portal"}</DialogContent>
      </Dialog>
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={openProductsDialog}
        onClose={() => setOpenProductsDialog(false)}
      >
        <DialogContent>
          {data?.productPriceList &&
            data?.productPriceList.map((product) => (
              <ProductCard data={product} />
            ))}
          <DialogActions>
            <PrimaryButton onClick={() => setOpenProductsDialog(false)}>
              close
            </PrimaryButton>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <MessageDialog
        dialogConfig={dialogConfig}
        setDialogConfig={setDialogConfig}
      />
    </>
  );
}

const CardBox = styled(Box)`
  width: 33%;
  height: 45%;
  ${(props) => props.theme.breakpoints.down("lg")} {
    width: 100%;
    height: 45%;
  }
  margin-bottom: 2rem;
  padding: 0.5rem;
`;

const StyledTypography = styled(Typography)`
  font-size: 0.7rem;
`;

const StyledPaper = styled(Paper)`
  margin-top: 0.5rem;
  max-width: 100%;
  border-radius: 1.5rem;
  padding: 0.5rem;
  background-color: ${(props) => props.theme.palette.background.default};
  height: 100%;
`;

const StyledBoxBuyButton = styled(Box)`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
`;

const StyledTypographyTransition = styled(Typography)`
  font-weight: 300;
  transition: 0.5s ease-in-out;
  color: ${(props) => props.theme.palette.primary.main};
  &:hover {
    font-weight: 700;
  }
`;

export default UpgradePlanCard;
